import type { CSSProperties, ReactNode } from "react";

export function Star({ className = "", color = "#F6D776", style }: { className?: string; color?: string; style?: CSSProperties }) {
  return (
    <svg viewBox="0 0 48 48" className={className} style={style} aria-hidden>
      <path
        d="M24 4.5 L29.2 17.6 L43 18.4 L32.3 27.3 L35.9 41 L24 33.4 L12.3 41.2 L15.6 27.4 L5 18.6 L18.9 17.4 Z"
        fill={color}
        stroke="#23324A"
        strokeWidth="2.6"
        strokeLinejoin="round"
        strokeDasharray="60 3 40 2"
      />
    </svg>
  );
}

export function Heart({ className = "", color = "#F08A6C", style }: { className?: string; color?: string; style?: CSSProperties }) {
  return (
    <svg viewBox="0 0 48 48" className={className} style={style} aria-hidden>
      <path
        d="M24 41 C10 31 4.5 23.5 6.2 15.8 C7.8 9 16.6 6.8 21.4 12.6 L24 15.7 L26.8 12.4 C31.6 6.9 40.4 9.1 41.8 15.9 C43.4 23.6 37.6 31.2 24 41 Z"
        fill={color}
        stroke="#23324A"
        strokeWidth="2.6"
        strokeLinejoin="round"
        strokeDasharray="70 3 30 2"
      />
    </svg>
  );
}

const STICKER_COLORS: Record<string, string> = {
  Mom: "#F08A6C",
  Dad: "#9CC9E8",
  "Grandma & Grandpa": "#F6D776",
  "Aunts & Uncles": "#E9C9F2",
  Friends: "#FFFFFF",
  Teacher: "#B9E3C6",
};

export function Sticker({ label, tilt = 0, testId }: { label: string; tilt?: number; testId?: string }) {
  return (
    <span
      data-testid={testId}
      className="sticker"
      style={{ background: STICKER_COLORS[label] || "#FFFFFF", transform: `rotate(${tilt}deg)` }}
    >
      {label}
    </span>
  );
}

export function DemoBadge() {
  return (
    <span data-testid="etsy-demo-badge" className="inline-flex items-center rounded-full border-2 border-dashed border-[#23324A] bg-[#F6D776] px-2.5 py-0.5 text-[11px] font-extrabold uppercase tracking-wide text-[#23324A]">
      Demo mode
    </span>
  );
}

export function PageHeader({ title, kicker, children }: { title: string; kicker?: string; children?: ReactNode }) {
  return (
    <header className="mb-8 flex flex-wrap items-end justify-between gap-4 fade-up">
      <div>
        {kicker && <p className="mb-1 text-xs font-bold uppercase tracking-[0.18em] text-[#23324A]/60">{kicker}</p>}
        <h1 className="font-display text-3xl font-black text-[#23324A] sm:text-4xl">{title}</h1>
      </div>
      {children}
    </header>
  );
}
